// extracted by mini-css-extract-plugin
module.exports = {"lifestyleImage":"LifestyleImage__lifestyleImage___229KN","stickyBackground":"LifestyleImage__stickyBackground___118hr"};